<iris-icon
  class="pill-icon"
  [name]="icon()"
  [size]="iconSmallSize"
  [usage]="iconDecorativeUsage"
  [colorToken]="iconColorToken()"
></iris-icon>
<span
  class="pill-text"
  [attr.data-test]="'pill-' + displayText()"
>
  {{ displayText() }}
</span>
